import React from 'react';
import SectionTag from '../components/SectionTag';
import ScrollReveal from '../components/ScrollReveal';
import { FiUsers, FiLayers, FiHeart } from 'react-icons/fi';

const CARDS = [
  {
    icon: <FiUsers size={22} color="#3FC4E3" />,
    title: 'The Problem',
    body: 'People in need struggle to discover local resources and support services. Non-profits work hard but lack the tools to reach the right people at the right time.',
  },
  {
    icon: <FiLayers size={22} color="#3FC4E3" />,
    title: 'Our Solution',
    body: 'TCCplus is a centralized platform where non-profits can publish resources and events, and people in need can find, explore, and connect with them instantly.',
  },
  {
    icon: <FiHeart size={22} color="#3FC4E3" />,
    title: 'Our Mission',
    body: 'To eliminate the gap between community organizations and the individuals they serve — making access to help simple, dignified, and immediate.',
  },
];

export default function About() {
  return (
    <section id="about" style={{ background: '#F8FAFC', padding: '120px 5%' }}>
      <div className="max-w-screen-xl mx-auto">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-16">
          <SectionTag label="ABOUT TCCplus" />
          <h2 style={{ fontFamily: 'popinsBold', fontSize: 'clamp(28px, 4vw, 44px)', color: '#1B1A28', marginBottom: '12px' }}>
            What is TCCplus?
          </h2>
          <p style={{ fontFamily: 'popinsRegular', fontSize: '16px', color: '#6B7280' }}>
            A platform built with purpose, designed for impact.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {CARDS.map((card, i) => (
            <ScrollReveal key={card.title} direction="up" delay={i * 150}>
              <div
                className="h-full transition-all duration-300 cursor-default"
                style={{
                  background: '#ffffff',
                  border: '1px solid #E5E5E5',
                  borderRadius: '16px',
                  padding: '32px',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.border = '1px solid rgba(63,196,227,0.5)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(63,196,227,0.1)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.border = '1px solid #E5E5E5';
                  e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.04)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div
                  className="flex items-center justify-center mb-5"
                  style={{ width: '48px', height: '48px', background: 'rgba(63,196,227,0.1)', borderRadius: '12px' }}
                >
                  {card.icon}
                </div>
                <h3 style={{ fontFamily: 'popinsSemiBold', fontSize: '18px', color: '#1B1A28', marginBottom: '12px' }}>
                  {card.title}
                </h3>
                <p style={{ fontFamily: 'popinsRegular', fontSize: '15px', color: '#6B7280', lineHeight: '1.7' }}>
                  {card.body}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
